<script setup>
// FLOW-05 (task 5.2, correção do Murilo de 13/10) — o erro e o aviso do editor de flow sem frase
// colorida: o ícone na cor do estado e o texto neutro, com o complemento (como resolver, o detalhe)
// no texto secundário, que quem usa escreve no slot. Como o `.err` do mockup aprovado (5.0): a
// caixa tem contorno neutro e nenhum fundo de cor. `solto` é a linha sem a caixa, embaixo de um
// campo (o JSON que não lê, o id inválido).
defineProps({
  // `erro` (rubi), `aviso` (âmbar) ou `info` (neutro).
  nivel: { type: String, default: 'erro' },
  solto: { type: Boolean, default: false },
  // Outro ícone e a cor dele, escritos por inteiro (o Tailwind só gera a classe que acha no código).
  icone: { type: String, default: null },
  cor: { type: String, default: null },
});

const ICONES = {
  erro: 'i-lucide-circle-x',
  aviso: 'i-lucide-triangle-alert',
  info: 'i-lucide-info',
};
const CORES = {
  erro: 'text-n-ruby-11',
  aviso: 'text-n-amber-11',
  info: 'text-n-slate-10',
};
</script>

<template>
  <div
    class="flex items-start gap-2 m-0 text-xs leading-5 text-n-slate-12"
    :class="
      solto
        ? ''
        : 'px-3 py-2 rounded-lg outline outline-1 -outline-offset-1 outline-n-weak'
    "
    :data-nivel="nivel"
  >
    <span
      class="size-3.5 mt-[3px] shrink-0"
      :class="[icone || ICONES[nivel], cor || CORES[nivel]]"
      aria-hidden="true"
      data-glifo
    />
    <div class="flex flex-col items-start flex-1 min-w-0 gap-1">
      <slot />
    </div>
  </div>
</template>
